import React, { useState, useContext, useMemo } from 'react'
import isEmpty from 'lodash/isEmpty'
import { useTranslation } from 'react-i18next'

import { mutation } from '../../helpers'
import { rawUpdateRoom } from '../../mutations'
import useMutation from 'components/graphql/hooks/useMutation'
import { ColorPicker, Form } from 'components/forms'
import { RestaurantContext } from 'sections/options/sections/RestaurantDesigner/RestaurantDesignerHandler'

import {
	StyledSelect,
	StyledSelectContainer,
	StyledIconItem,
	StyledColorPicker
} from './styled/common'

import { ReactComponent as FloorIcon } from './icons/floor.svg'
import { ReactComponent as RoomIcon } from './icons/room.svg'
import { ReactComponent as Edit } from './icons/edit.svg'
import Button from 'components/Button'

const DropdownMenus = (props) => {
	const { toggle3d, is3dShown } = props
	const [t] = useTranslation()
	const [updateRoom] = useMutation(rawUpdateRoom)

	const getOptions = (path, collectionName) => {
		if(!path) {
			return []
		}

		const templates = {
			floors: { text: t('restaurant_designer_section.strings.floor_title'), prop: 'number' },
			rooms: { text: '', prop: 'caption' }
		}

		return !isEmpty(path[collectionName])
			? path[collectionName].map(item => ({ value: item.id, label: `${templates[collectionName].text} ${item[templates[collectionName].prop]}` }))
			: []
	}

	const { currentProjectIds, setCurrentProjectIds, currentProjectData, setCurrentProjectData } = useContext(RestaurantContext)
	const [floorOptions, setFloorOptions] = useState(getOptions(currentProjectData.projectData, 'floors'))
	const [roomOptions, setRoomOptions] = useState(getOptions(currentProjectData.floorData, 'rooms'))


	useMemo(() => {
		setFloorOptions(getOptions(currentProjectData.projectData, 'floors'))
		setRoomOptions(getOptions(currentProjectData.floorData, 'rooms'))
	}, [currentProjectIds, currentProjectData])

	const updateRoomColor = (roomColor) => {
		setCurrentProjectData(
			{
				...currentProjectData,
				roomData: {
					...currentProjectData.roomData,
					roomColor
				}
			}
		)
		mutation(updateRoom, {
			fields: {
				id: currentProjectIds.roomId,
				roomColor
			}
		}).then(result => {
			setCurrentProjectData(
				{
					...currentProjectData,
					roomData: {
						...currentProjectData.roomData,
						roomColor: result.data.cashAssist.updateRoom[0].roomColor
					}
				}
			)
		})
	}

	return (
		<div style={{ display: 'flex' }}>
			<Form
				key={currentProjectData.floorData.number + currentProjectData.roomData.caption}
				initialValues={{
					currentFloor: currentProjectIds.floorId,
					currentRoom: currentProjectIds.roomId
				}}>
				{()=>(
					<div style={{ display: 'flex' }}>
						<StyledSelectContainer >
							<StyledIconItem>
								<FloorIcon/>
							</StyledIconItem>
							<div onClick={e=>e.stopPropagation()}>
								<StyledSelect key={currentProjectIds.floorId} field={'currentFloor'} onChange={(option) => {
									const newFloor = currentProjectData.projectData.floors.find(item=>item.id === option.value)
									const defaultRoomId = newFloor.rooms[0].id
									setCurrentProjectIds({ ...currentProjectIds, floorId: option.value, roomId: defaultRoomId })
								}} options={floorOptions}
								value={currentProjectIds.floorId}
								style={{ background: '#ffffff' }}
								/>
							</div>
						</StyledSelectContainer>
						<StyledSelectContainer>
							<StyledIconItem>
								<RoomIcon/>
							</StyledIconItem>
							<div onClick={e => e.stopPropagation()}>
								<StyledSelect key={currentProjectIds.roomId} field={'currentRoom'} onChange={(option) => {
									setCurrentProjectIds({ ...currentProjectIds, roomId: option.value })
								}} options={roomOptions}
								value={currentProjectIds.roomId}
								style={{ background: '#ffffff' }}
								/>
							</div>
						</StyledSelectContainer>
						<StyledSelectContainer>
							<StyledIconItem>
								<Edit/>
							</StyledIconItem>
							<StyledColorPicker>
								<ColorPicker onChange={updateRoomColor} value={currentProjectData.roomData.roomColor}/>
							</StyledColorPicker>
						</StyledSelectContainer>
					</div>
				)}
			</Form>
			<Button status={is3dShown ? 'active' : 'green'} onClick={toggle3d} text={is3dShown ? 'Show bird view' : 'Show 3D'} />
		</div>
	)
}

export default DropdownMenus
